import { render } from "./JewelleryVariants.vue?vue&type=template&id=7926ebc3"
import script from "./JewelleryVariants.vue?vue&type=script&lang=js"
export * from "./JewelleryVariants.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__